<template>
  <div
    id="components-layout-demo-basic"
    :class="{ 'page-heder': true, newHome: now }"
  >
    <a-layout>
      <a-layout-header>
        <img
          class="page-img"
          src="../image/logo.png"
          v-if="$i18n.locale === 'zh-CN' && !now"
        />
        <img
          class="page-img"
          src="../image/logo_en.png"
          v-if="$i18n.locale === 'en-US' && !now"
        />
        <img
          class="page-img"
          src="../image/002.png"
          v-if="$i18n.locale === 'zh-CN' && now"
        />
        <img
          class="page-img"
          src="../image/001.png"
          v-if="$i18n.locale === 'en-US' && now"
        />

        <!--overlayClassName="menUStyle"-->
        <a-menu
          v-model="current"
          mode="horizontal"
          @click="handleClick"
          class="menClss"
        >
          <a-menu-item key="1" class="maenSpan">
            {{ $tc('lang.header.Home') }}</a-menu-item
          >
          <a-sub-menu>
            <span slot="title" class="maenSpan">{{
              $tc('lang.header.Service')
            }}</span>
            <a-menu-item key="2">{{
              $tc('lang.header.Product_Quality_Control')
            }}</a-menu-item>
            <a-menu-item key="3">{{
              $tc('lang.header.Vendor_Assessment_Service')
            }}</a-menu-item>
          </a-sub-menu>
          <a-menu-item key="10" class="maenSpan">{{
            $tc('lang.header.About_us')
          }}</a-menu-item>
          <a-sub-menu>
            <span slot="title" class="maenSpan">{{
              $tc('lang.header.Guide')
            }}</span>
            <a-menu-item key="6">
              {{ $tc('lang.header.Get_started') }}</a-menu-item
            >
            <a-menu-item key="8">{{
              $tc('lang.header.Reference_Cases')
            }}</a-menu-item>
            <a-menu-item key="9">FAQ</a-menu-item>
          </a-sub-menu>
          <a-sub-menu>
            <span slot="title" class="maenSpan">Language</span>
            <a-menu-item key="11">{{ $tc('lang.header.zh') }}</a-menu-item>
            <a-menu-item key="12">English</a-menu-item>
          </a-sub-menu>
        </a-menu>
        <router-link to="/login" class="page-spn">
          <p class="page-p">{{ $tc('lang.header.Log_in') }}</p>
        </router-link>
      </a-layout-header>
    </a-layout>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      current: ['1'],
      now: false,
    };
  },
  created() {
    this.current = [];
    const urlName = window.location.pathname;
    if (urlName === '/about') {
      this.current.push('10');
    }
    if (urlName === '/home') {
      this.current.push('1');
      this.now = 1;
    }
    if (urlName === '/qaqc') {
      this.current.push('2');
    }
    if (urlName === '/faq') {
      this.current.push('9');
    }
    if (urlName === '/fastStart') {
      this.current.push('6');
    }
    if (urlName === '/reportDemo') {
      this.current.push('8');
    }
    if (urlName === '/serveSupplier') {
      this.current.push('3');
    }
    // 获取国际化sessionStorage信息
    if (sessionStorage.getItem('lang') !== null) {
      this.$i18n.locale = JSON.parse(sessionStorage.getItem('lang')) || '';
    }
  },
  methods: {
    onCollapse(collapsed, type) {
      console.log(collapsed, type);
    },
    handleClick(e) {
      // 页面路由判断
      this.current = [];
      if (e.key === '1') {
        this.current.push(e.key);
        this.$router.push('/home');
      }
      if (e.key === '9') {
        this.current.push(e.key);
        this.$router.push('/faq');
      }
      if (e.key === '6') {
        this.current.push(e.key);
        this.$router.push('/fastStart');
      }
      if (e.key === '10') {
        this.current.push(e.key);
        this.$router.push('/about');
      }
      if (e.key === '2') {
        this.current.push(e.key);
        this.$router.push('/qaqc');
      }
      if (e.key === '8') {
        this.current.push(e.key);
        this.$router.push('/reportDemo');
      }
      if (e.key === '3') {
        this.current.push(e.key);
        this.$router.push('/serveSupplier');
      }
      if (e.key === '11') {
        console.log('changeLangEvent');
        if (this.$i18n.locale === 'en-US') {
          this.$i18n.locale = 'zh-CN'; //关键语句
          console.log('zh:', this.$i18n.locale);
          sessionStorage.setItem(
            'lang',
            JSON.stringify(this.$i18n.locale || ''),
          );
        }
      }
      if (e.key === '12') {
        console.log('changeLangEvent');
        if (this.$i18n.locale === 'zh-CN') {
          this.$i18n.locale = 'en-US'; //关键语句
          console.log('en:', this.$i18n.locale);
          sessionStorage.setItem(
            'lang',
            JSON.stringify(this.$i18n.locale || ''),
          );
        }
      }
    },
    onBreakpoint(broken) {
      console.log(broken);
    },
  },
};
</script>

<style lang="less">
.ant-menu-submenu-popup {
  font-weight: 700;
  font-size: 16px;
  background-color: rgba(255, 255, 255, 0.1);
}
.ant-menu-submenu > .ant-menu {
  background-color: rgba(255, 255, 255, 0.1);
}
.ant-menu-item:hover {
  color: #ffffff;
}
.page-heder {
  position: relative;
  z-index: 10000;
  background: transparent;
  .langStyle {
    display: inherit;
  }
  .menClss {
    background: transparent;
    .maenSpan {
      font-size: 18px;
      font-weight: 600;
      /*background-image: -webkit-linear-gradient(bottom, red, #fd8403, yellow);*/
      /*-webkit-background-clip: text;*/
      /*-webkit-text-fill-color: transparent;*/
    }
    li {
      height: 50px;
    }
  }
  .ant-layout {
    background: transparent;
  }
  .ant-layout-header {
    background-color: transparent;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .ant-menu-horizontal {
    // margin-left: 22%;
    display: inline-block;
    line-height: 50px;
    border-bottom: 0 solid #e8e8e8;
  }
  /*背景图片*/
  .page-img {
    height: 100%;
    /*width: 18%;*/
    background-size: 100% 100%;
    text-indent: -9999em;
    z-index: 1000;
    // margin-top: -10px;
    // margin-left: -6%;
  }
  /*运营字体背景*/
  .page-spn {
    // float: right;
    border: 1px solid #1890ff;
    margin-right: 5%;
    clear: right;
    // background-color: #3e87e3;
    vertical-align: top;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width: 100px;
    border-radius: 10px;
    &:hover {
      border: 1px solid rgba(24, 144, 255, 0.5);
      background-color: rgba(24, 144, 255, 0.5);
    }
  }
  .page-p {
    color: #000;
    font-size: 16px;
    // top: 5px;
  }
}
.newHome {
  // .ant-menu-item:hover {
  //   color: #1890ff;
  // }
  .maenSpan,
  .ant-menu {
    color: #fff;
  }
  .ant-menu-item-selected {
    color: #1890ff;
  }
  // .page-heder {
  .page-spn {
    &:hover {
      border: 1px solid rgba(255, 255, 255, 0.4);
      background-color: rgba(255, 255, 255, 0.4);
    }
  }
  .page-p {
    color: #fff;
    &:hover {
      color: #1890ff;
    }
  }
  // }
  @media all and (max-width: 1200px) {
    & {
      width: 1200px;
    }
  }
}
</style>
